export default {
  applicant: 'applicant',
  organization: 'organization',
  pass: 'pass',
  visitors: 'visitors',
  edit: 'edit',
  apply: 'apply',
  approve: 'approve',
  transport: 'transport'
}
